import Cookies from "js-cookie";
import { DateTime } from "luxon";
import { getNavigate } from "./navigate";

const LOGIN_URL = import.meta.env.VITE_PUBLIC_LOGIN_URL!;

async function getToken({
  username,
  password,
}: {
  username: string;
  password: string;
}) {
  const body = new URLSearchParams();
  body.append("username", username);
  body.append("password", password);

  const res = await fetch(LOGIN_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: body.toString(),
  });

  if (res.status >= 500) {
    throw new Error("Server error");
  }

  if (res.status >= 400) {
    throw new Error(await res.text());
  }

  return await res.json();
}

function isTokenResult(
  res: unknown,
): res is { type: "Success"; token: string } {
  return typeof res === "object" && res !== null && "token" in res;
}

function setCookie(token: string) {
  Cookies.set("elevatetoken", token, {
    expires: DateTime.now().plus({ months: 6 }).toJSDate(),
  });
}

export async function authenticate(username: string, password: string) {
  const res = await getToken({
    username,
    password,
  });

  if (isTokenResult(res)) {
    setCookie(res.token);
    return res;
  } else {
    return undefined;
  }
}

export function logOut() {
  Cookies.remove("elevatetoken");
  const navigate = getNavigate();
  navigate("/login");
}
